import * as React from "react";
const SvgSquareUnchecked = props => <svg xmlns="http://www.w3.org/2000/svg" width={18} height={19} fill="none" viewBox="0 0 18 19" {...props}><rect width={17} height={17} x={0.5} y={1} fill="#fff" stroke="#BDBDBD" rx={3.5} /></svg>;
export { SvgSquareUnchecked as ReactComponent };